// Keep global middleware non-blocking.
// Access control is handled by explicit named middleware on protected pages.
export default defineNuxtRouteMiddleware(() => {});
